<div class="user-inner-menu-wrapper" [class.sticky-to-top]="stickyToTop" [class.in-mobile-sidenav]="inMobileSidenav">
  <div class="user-menu-header">
    <div class="mb-16-px">
      <app-user-image-block [activeCustomer]="activeCustomer$ | async" [showActions]="false" [showUsername]="true">
      </app-user-image-block>
    </div>
    <div class="profile-summary-block">
      @if (activeCustomer$ | async; as customer) {
      <div class="profile-info-block">
        <p class="profile-info-label">Phone</p>
        <p class="profile-info-value">
          <a href="tel:{{customer.phoneNumber || ''}}">{{customer.phoneNumber || '-'}}</a>
        </p>
      </div>
      <div class="profile-info-block">
        <p class="profile-info-label">Email</p>
        <p class="profile-info-value">
          <a href="mailTo:{{customer.emailAddress || ''}}">{{customer.emailAddress || '-'}}</a>
        </p>
      </div>
      <div class="profile-info-block">
        <p class="profile-info-label">Main shipping address</p>
        <p class="profile-info-value">

          <a href="#">@if(currentAddress$ | async; as address){
            {{address.streetLine1}}@if(address.streetLine2){-{{address.streetLine2}}}, {{address.postalCode}},
            {{address.city}}
            } @else {-}</a>

        </p>
      </div>
      }

    </div>
  </div>
  <div class="user-menu-body">
    <div class="user-inner-navigation-menu">
      @for (item of profileMenuList; track item) {
      @if(item.disabled){

      } @else {
      <a (click)="triggerEventsAfterLinkClick(item)" pRpple class="menu-link" [class.active]="item.active"
        [routerLink]="item.routerLink" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
        <img [src]="item.active ? item.activeIconUrl : item.iconUrl" alt="{{item.label}}" />
        <span class="text">{{item.label}} @if (item.count) {({{item.count}})}</span>
      </a>
      }

      }
    </div>
  </div>
</div>
